module.exports = __webpack_public_path__ + "static/media/hallstatt-3609863_1920.76c530e3.jpg";